import styled from "styled-components";

export const Wrapper = styled.div`
  height: 100%;
  min-width: 7rem;
  display: grid;
  grid-template-rows: repeat(3, 1fr);
  /* background-color: #16161a; */
  background-color: #656565;
  z-index: 100;
`;

